import {Presenter} from '../../../../support/with_presenter';

export class DraggableParticipantBlockPresenter implements Presenter {
    public isEditModalOpen = false;

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public onEditClick = () => {
        this.isEditModalOpen = true;
    };

    public closeEditModal = () => {
        this.isEditModalOpen = false;
    };
}
